import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21.707 3.707a1 1 0 0 0-1.414-1.414l-18 18a1 1 0 1 0 1.414 1.414zM10.184 3.55C10.899 2 13.1 2 13.816 3.55l.98 2.126.102.219-4.505 4.545-4.504 4.546-.146-.135-3.292-3.044c-1.253-1.159-.572-3.254 1.123-3.454L8.223 7.8zm8.664 4.615 1.578.188c1.695.2 2.376 2.295 1.123 3.454l-3.437 3.179.912 4.592c.332 1.674-1.45 2.968-2.939 2.135L12 19.426l-4.085 2.287a1.98 1.98 0 0 1-2.263-.213z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: n };
export {
  i as default,
  n as render
};
//# sourceMappingURL=ic_star_stroked_filled-Br2Gad-d.js.map
